<template>
  <v-dialog v-model="dialog" width="360">
    <v-card class="csv-download">
      <h5 class="pa-3">
        観測所データ CSVダウンロード
      </h5>
      <div class="d-flex pa-3">
        <datetime
          type="date"
          v-model="startDate"
          :max-datetime="endDate"
          class="datetime-area"
        >
        </datetime>
        <div class="mx-2">〜</div>
        <datetime
          type="date"
          v-model="endDate"
          :max-datetime="limitDate"
          class="datetime-area"
        >
        </datetime>
      </div>

      <v-card tile flat class="pa-3">
        <v-btn-toggle v-model="toggle" dense class="mb-2">
          <v-btn small value="rain" width="90">
            雨量
          </v-btn>
          <v-btn small value="stage" width="90">
            水位
          </v-btn>
          <v-btn small value="raintank" width="90">
            雨水タンク
          </v-btn>
        </v-btn-toggle>

        <v-btn-toggle
          v-model="displayInterval"
          dense
          class="my-2"
          v-if="toggle === 'raintank'"
        >
          <v-btn small :value="10" width="90">
            10分毎
          </v-btn>
          <v-btn small :value="60" width="90">
            時間毎
          </v-btn>
          <v-btn small :value="24" width="90">
            24時間毎
          </v-btn>
        </v-btn-toggle>

        <v-simple-table class="mt-3">
          <tbody>
            <tr>
              <td class="py-1 caption" style="width: 200px">全観測拠点</td>
              <td>
                <v-btn x-small @click="download(null)" :disabled="disabled">
                  ダウンロード
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <v-simple-table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="obs in rows" :key="obs.id">
              <td class="py-2 caption" style="width: 200px">{{ obs.name }}</td>
              <td>
                <v-btn x-small @click="download(obs)" :disabled="disabled">
                  ダウンロード
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close()">
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import * as axiosHelper from "../utils/axiosHelper";
export default {
  name: "CsvDownload",
  props: {
    dialog: Boolean
  },
  data() {
    return {
      limitDate: moment.utc().toISOString(),
      startDate: moment.utc().toISOString(),
      endDate: moment.utc().toISOString(),
      disabled: false,
      toggle: "rain",
      displayInterval: 10
    };
  },
  computed: {
    rains() {
      const targets = [
        "3329_23",
        "3329_70",
        "3329_12",
        "30000_44132",
        "3329_1",
        "3329_21",
        "3329_20",
        "3329_24",
        "3329_19",
        "3329_18"
      ];
      const arr = this.$store.getters.observatories;
      return arr.filter(r => r.type === 1 && targets.includes(r.id));
    },
    stages() {
      const targets = ["890_1", "3329_85"];
      const arr = this.$store.getters.observatories;
      return arr.filter(r => r.type === 4 && targets.includes(r.id));
    },
    rainTanks() {
      const arr = this.$store.getters.observatories;
      return arr.filter(r => r.type === 65);
    },
    rows() {
      if (this.toggle === "rain") {
        return this.rains;
      } else if (this.toggle === "stage") {
        return this.stages;
      } else {
        return this.rainTanks;
      }
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },

    async fetchReals(obs, date1, date2) {
      const params = {
        type: obs.type,
        id: obs.id,
        date1: date1,
        date2: date2
      };
      if (obs.dynamodb) {
        params.dynamodb = obs.dynamodb;
      }
      const res = await axiosHelper.get("/observatories/reals", params);
      return res.reals;
    },

    getTargetCsv(reals, timeseries) {
      let csv = "";
      if (this.toggle === "rain") {
        csv = "観測日時,10分雨量,累計雨量";
      } else {
        csv = "観測日時,水位";
      }
      if (this.toggle === "raintank") {
        if (this.displayInterval === 60) {
          timeseries = timeseries.filter(ts => ts.substr(-2) === "00");
        } else if (this.displayInterval === 24) {
          timeseries = timeseries.filter(ts => ts.substr(-5) === "15:00");
        }
      }
      timeseries.forEach(ts => {
        const line = {
          date: moment
            .utc(ts, "YYYY/MM/DD HH:mm")
            .add(9, "hours")
            .format("YYYY/MM/DD HH:mm"),
          min10: "",
          total: "",
          level: ""
        };

        const row = reals.find(r => r.date === ts);
        if (row !== undefined) {
          if (row.min10 !== undefined) {
            line.min10 = row.min10.toFixed(2);
          }
          if (row.total !== undefined) {
            line.total = row.total.toFixed(2);
          }
          if (row.level !== undefined) {
            line.level = row.level.toFixed(2);
          }
        }
        if (this.toggle === "rain") {
          csv += `\r\n${line.date},${line.min10},${line.total}`;
        } else {
          csv += `\r\n${line.date},${line.level}`;
        }
      });
      return csv;
    },

    async download(obs) {
      if (this.disabled === true) {
        return;
      }
      const d1 = moment.utc(this.startDate);
      const d2 = moment.utc(this.endDate);
      if (d1.isAfter(d2) === true) {
        alert("日付範囲を確認してください。");
        return;
      }
      const d = d1.clone().add(31, "days");
      if (d.isSameOrBefore(d2) === true) {
        alert("31日以内で指定して下さい。");
        return;
      }

      this.disabled = true;
      try {
        const start = moment.utc(
          d1.subtract(1, "day").format("YYYYMMDD1451"),
          "YYYYMMDDHHmm"
        );
        const end = moment.utc(d2.format("YYYYMMDD1450"), "YYYYMMDDHHmm");

        const timeseries = [];
        const current = start
          .clone()
          .add(10 - (start.minute() % 10), "minutes");
        while (current.isSameOrBefore(end)) {
          timeseries.push(current.format("YYYY/MM/DD HH:mm"));
          current.add(10, "minutes");
        }

        let csv = "";
        if (obs === null) {
          let csvs = [];
          for (const o of this.rows) {
            const reals = await this.fetchReals(
              o,
              start.format("YYYY/MM/DD HH:mm"),
              end.format("YYYY/MM/DD HH:mm")
            );
            const targetCsv = this.getTargetCsv(reals, timeseries);
            const current = targetCsv.split("\r\n");
            if (this.toggle === "rain") {
              current.unshift(`場所,${o.name},${o.name}`);
            } else {
              current.unshift(`場所,${o.name}`);
            }
            if (csvs.length === 0) {
              csvs = current;
            } else {
              for (let i = 0; i < current.length; i++) {
                const arr = current[i].split(",");
                csvs[i] = csvs[i] + "," + arr[1];
                if (this.toggle === "rain") {
                  csvs[i] = csvs[i] + "," + arr[2];
                }
              }
            }
          }
          csv = csvs.join("\r\n");
        } else {
          const reals = await this.fetchReals(
            obs,
            start.format("YYYY/MM/DD HH:mm"),
            end.format("YYYY/MM/DD HH:mm")
          );
          csv = this.getTargetCsv(reals, timeseries);
        }

        let filename = "全観測拠点_";
        if (obs) {
          filename = obs.name + "_";
        }
        if (this.toggle === "rain") {
          filename += "雨量_";
        } else if (this.toggle === "stage") {
          filename += "水位_";
        } else {
          filename += "雨水タンク_";
        }
        filename +=
          start.format("YYYYMMDD") + "_" + end.format("YYYYMMDD") + ".csv";

        const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
        var elm = document.createElement("a");
        elm.download = filename;
        elm.href = URL.createObjectURL(
          new Blob([bom, csv], { type: "text/csv" })
        );
        elm.dataset.downloadurl = ["text/csv", elm.download, elm.href].join(
          ":"
        );
        elm.click();

        this.disabled = false;
      } catch (e) {
        this.disabled = false;
        console.error(e);
      }
    }
  }
};
</script>

<style lang="scss">
.csv-download {
  .datetime-area {
    .vdatetime-input {
      cursor: pointer !important;
      padding: 3px;
      background-color: #1976d2 !important;
      width: 140px;
      color: white !important;
      border-radius: 1em;
      text-align: center;
    }
  }
}
</style>
